import(/* webpackMode: "eager" */ "/vercel/path0/client/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/client/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/app/services/components/ProcessSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/app/services/components/ServiceCardsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/client/src/components/ui/AppIcon.tsx");
